import { optionalContextFactory } from '../../../hooks';
import { ResponsiveModalState } from './responsive-modal.types';

const [context, useResponsiveModalContextMethod] = optionalContextFactory<ResponsiveModalState>(
  {} as ResponsiveModalState
);

export type ResponsiveModalProviderProps = React.PropsWithChildren<ResponsiveModalState>;

export const ResponsiveModalProvider = ({ children, ...props }: ResponsiveModalProviderProps) => {
  return <context.Provider value={props}>{children}</context.Provider>;
};

export { useResponsiveModalContextMethod as useResponsiveModalContext };
